import { render, staticRenderFns } from "./high-praise.vue?vue&type=template&id=71f4569c&scoped=true&"
import script from "./high-praise.vue?vue&type=script&lang=js&"
export * from "./high-praise.vue?vue&type=script&lang=js&"
import style0 from "./high-praise.vue?vue&type=style&index=0&id=71f4569c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4569c",
  null
  
)

export default component.exports